import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ContentEnum, GenericContentElement, GridCell, ImageContentElement, SectionData } from '../../models/sections-model';
import { Product } from '../../data/product-data';
import { NbTabComponent, NbTabsetComponent } from '@nebular/theme';
import { EnumToValuePipe } from '../../pipes/enum-to-value.pipe';


@Component({
  selector: 'kw-product-renderer',
  templateUrl: './product-renderer.component.html',
  styleUrls: ['./product-renderer.component.scss']
})
export class ProductRendererComponent implements OnInit {
  @Input() data:SectionData;
  @Input() edit:boolean;
  @Input() heading:string;
  @Input() title:string;
  product:Product;
  
  gridCells:GridCell[];
  galleryCell:GridCell;
  accordionCells:GridCell[] = [];
  tabCells:GridCell[] = [];
  productShare:GridCell;
  productReviews:GridCell;
  layoutClass = "default";

  ContentEnum = ContentEnum;

  
  selectedTab:NbTabComponent;
  tabsLoaded = false;
  
  @ViewChild('productTab') tabsComp:NbTabsetComponent;
  
  
  constructor(private cdref: ChangeDetectorRef, private el:ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.gridCells = this.data.gridOptions.gridCells;
    //console.log(this.gridCells);
    this.product = this.data.product;

    const imgCont:GenericContentElement<ImageContentElement> = {
      elId:"hasadhasj",
      name:"hkjhfjsdh",
      content:{
        imgSrc:"https://placehold.co/540x675/FFFFFF/000?text=Detail+Image"
      }
    }
    console.log(imgCont)

    this.populateContentElements(this.product,this.gridCells)
  }


  populateContentElements(product:Product,gridCells:GridCell[]){
    for(let i=0;i < gridCells.length;i++){
      if(ContentEnum[gridCells[i]?.contentEnum] == "Gallery"){
        this.populateGallery(gridCells[i],product);
        this.galleryCell = gridCells[i];
      }
      if(ContentEnum[gridCells[i]?.contentEnum] == "Product Standard Features"){
        //gridCells[i].heading.headerText = "Product Standard Features"
        this.accordionCells.push(gridCells[i]);
      }
      if(ContentEnum[gridCells[i]?.contentEnum] == "Product Long Description"){
        this.tabCells.push(gridCells[i])
        this.accordionCells.push(gridCells[i]);
      }
      if(ContentEnum[gridCells[i]?.contentEnum] == "Product Reviews"){
        this.tabCells.push(gridCells[i])
        this.productReviews = gridCells[i];
      }
      if(ContentEnum[gridCells[i]?.contentEnum] == "Product Share"){
        this.productShare = gridCells[i]
      }
      
    }
   
    if(this.tabCells.length > 1){
      setTimeout(() => {
        this.tabsLoaded = true;
      }, 200);
      
    }


  }

  populateGallery(galleryCell:GridCell,product:Product){
    let largeImageUrlCntEl = galleryCell.contentElements.find(contentElement => contentElement.fieldName == "largeImageUrl");
    if(largeImageUrlCntEl != undefined && largeImageUrlCntEl.imgSrc == undefined){
      largeImageUrlCntEl.imgSrc =  product.largeImageUrl?product.largeImageUrl: "http://kwikstore-dev/assets/avon-1/man_in_shades.jpg";
    }
    let additionalImageOneCntEl = galleryCell.contentElements.find(contentElement => contentElement.fieldName == "additionalImageOne");
    if(additionalImageOneCntEl != undefined && additionalImageOneCntEl.imgSrc == undefined){
      additionalImageOneCntEl.imgSrc =  product.additionalImageOne?product.additionalImageOne:"https://placehold.co/540x675/FFFFFF/000?text=Additional+Image+One";
    }
    let additionalImageTwoCntEl = galleryCell.contentElements.find(contentElement => contentElement.fieldName == "additionalImageTwo");
    if(additionalImageTwoCntEl != undefined && additionalImageTwoCntEl.imgSrc == undefined){
      additionalImageTwoCntEl.imgSrc =  product.additionalImageOne?product.additionalImageOne:"https://placehold.co/540x675/FFFFFF/000?text=Additional+Image+Two";
    }
    let additionalImageThreeCntEl = galleryCell.contentElements.find(contentElement => contentElement.fieldName == "additionalImageThree");
    if(additionalImageThreeCntEl != undefined && additionalImageThreeCntEl.imgSrc == undefined){
      additionalImageThreeCntEl.imgSrc =  product.additionalImageOne?product.additionalImageOne:"https://placehold.co/540x675/FFFFFF/000?text=Additional+Image+Three";
    }
    let additionalImageFourCntEl = galleryCell.contentElements.find(contentElement => contentElement.fieldName == "additionalImageFour");
    if(additionalImageFourCntEl != undefined && additionalImageFourCntEl.imgSrc == undefined){
      additionalImageFourCntEl.imgSrc =  product.additionalImageOne?product.additionalImageOne:"https://placehold.co/540x675/FFFFFF/000?text=Additional+Image+Four";
    }

    //console.log(galleryCell)
  }

  populateID(idCell:GridCell,product:Product){
    let productNameCntEl = idCell.contentElements.find(contentElement => contentElement.fieldName == "productName");
    if(productNameCntEl != undefined){
      productNameCntEl.text =  product.productName?product.productName: "No Product Name";
    }
    let productIdCntEl = idCell.contentElements.find(contentElement => contentElement.fieldName == "productId");
    if(productIdCntEl != undefined){
      productIdCntEl.text =  product.productId?product.productId: "No Product Id";
    }
    let productBrandCntEl = idCell.contentElements.find(contentElement => contentElement.fieldName == "brand");
    if(productBrandCntEl != undefined){
      productBrandCntEl.text =  product.brandName?product.brandName: "No Brand";
    }
    let productCatCntEl = idCell.contentElements.find(contentElement => contentElement.fieldName == "category");
    if(productCatCntEl != undefined){
      productCatCntEl.text =  product.categoryName?product.categoryName: "No Category Name";
    }

  }
  isClicked(){
    this.cdref.detectChanges();
  }

  whatDeFuck(e){
    console.log(e)
  }

  onChangeTab(e:NbTabComponent){
    this.selectedTab = e;
    /* if(this.selectedTab == undefined){
      this.selectedTab = e
    }else{
      if(e.tabId === this.selectedTab.tabId){
        console.log("It's the same ---- Doing Nothing")
      }else{
        console.log("It's NOT the same ---- Doing Somethingf")
        this.tabsComp.selectTab(e);
        this.selectedTab = e;
        e.active = true;
        this.tabsComp.tabs.forEach( ( tab: NbTabComponent, index: number, array: any[] ) => {
          if ( tab.tabId != e.tabId && tab.active === true ) {
            tab.active = false
          }
        })
      }
      
    } */
    
    
  }

}
